import React, { Component,useState, useEffect } from 'react';
import {Dropdown, Modal, Button, Container} from 'react-bootstrap';
import { Link, useHistory ,useLocation} from 'react-router-dom';
import moment from 'moment';
import { Trans } from 'react-i18next';
import sulog from '../../image/sulog.png';
import style from "./../../mystyle.module.css";
import "../../custom.css"

import classNames from 'classnames';





function Navbar() {

  const history = useHistory();

  const current = new Date();
  const curdate = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;

  function toggleOffcanvas() {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }

  function toggleRightSidebar() {
    document.querySelector('.right-sidebar').classList.toggle('open');
  }

  function logout() {
    localStorage.removeItem('user-info');
    history.push("/user-pages/login-1")
  }
  function editprofile() {
    history.push("/user-pages/editprofile")
  }

  let userinfo = JSON.parse(localStorage.getItem("user-info"))
  let src = require("../../assets/images/faces/face1.jpg");
  let name = 'Anonymous';
  let regdate = curdate;
  let email = "";
  let role  = "Not Specified"
  let curpage = ""
  const location = useLocation();
  curpage = location.pathname;


  const isRegisterPage = history.location.pathname === '/user-pages/register-1';

  if(userinfo){
    name = userinfo.name;
    if(userinfo.picture) src  = userinfo.picture;
    regdate = userinfo.regdate;
    regdate = moment(regdate).format('MMMM Do YYYY');
    email   = userinfo.email;
    role =   userinfo.role;
  }
  else {
     if(curpage != "/user-pages/forgotpass") {
       if(isRegisterPage) {
         history.push("/user-pages/register-1")
       }
       else{
         history.push("/user-pages/login-1")
       }
     }
  }

  // const [img, setImg] = useState();
  //
  // const fetchImage = async () => {
  //   const res = await fetch(src,{mode:'cors'});
  //   const imageBlob = await res.blob();
  //   const imageObjectURL = URL.createObjectURL(imageBlob);
  //   setImg(imageObjectURL);
  // };
  //
  // useEffect(() => {
  //   fetchImage();
  // }, []);

  const [isShow, setShow] = React.useState(false)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const styleObj = {
    marginLeft : "64%",
    marginTop  : "85.92px",
  }
  const modalbody = {
    margin : "0px",
    width : "454.17px"
  }

  return (

        <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <div className="app-logo">
            <div className={style.dashlogo} >
              <div><img  className={style.dashlogo2} src={sulog} alt="logo"/></div>
            </div>
            <div> <p className={style.dashheading}>Sudabelt</p></div>
          </div>
          {/*<Link className="navbar-brand brand-logo-mini" to="/"><img src={require('../../assets/images/logo-mini.svg')}*/}
          {/*                                                           alt="logo"/></Link>*/}
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-stretch">
          <button className="navbar-toggler navbar-toggler align-self-center" type="button"
                  onClick={() => document.body.classList.toggle('sidebar-icon-only')}>
            <span className="mdi mdi-menu "></span>
          </button>
          <div className="search-field d-none d-md-block">
            <form className="d-flex align-items-center h-100" action="#">
              <div className="input-group">
                <div className="input-group-prepend bg-transparent">
                  <i className="input-group-text border-0 mdi mdi-magnify"></i>
                </div>
                <input type="text" className="form-control bg-transparent border-0" placeholder="Search projects"/>
              </div>
            </form>
          </div>
          <ul className="navbar-nav navbar-nav-right">
            <li className="nav-item">
              <Dropdown alignRight>
                <Dropdown.Toggle className="nav-link count-indicator">
                  <i className="mdi mdi-bell "></i>
                  <span className="count-symbol bg-danger"></span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu navbar-dropdown preview-list">
                  <h6 className="p-3 mb-0"><Trans>Notifications</Trans></h6>
                  <div className="dropdown-divider"></div>
                  <Dropdown.Item className="dropdown-item preview-item" onClick={evt => evt.preventDefault()}>
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-success">
                        <i className="mdi mdi-calendar"></i>
                      </div>
                    </div>
                    <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                      <h6 className="preview-subject font-weight-normal mb-1"><Trans>Event today</Trans></h6>
                      <p className="text-gray ellipsis mb-0">
                        <Trans>Just a reminder that you have an event today</Trans>
                      </p>
                    </div>
                  </Dropdown.Item>
                  <div className="dropdown-divider"></div>
                  <Dropdown.Item className="dropdown-item preview-item" onClick={evt => evt.preventDefault()}>
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-warning">
                        <i className="mdi mdi-settings"></i>
                      </div>
                    </div>
                    <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                      <h6 className="preview-subject font-weight-normal mb-1"><Trans>Settings</Trans></h6>
                      <p className="text-gray ellipsis mb-0">
                        <Trans>Update dashboard</Trans>
                      </p>
                    </div>
                  </Dropdown.Item>
                  <div className="dropdown-divider"></div>
                  <Dropdown.Item className="dropdown-item preview-item" onClick={evt => evt.preventDefault()}>
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-info">
                        <i className="mdi mdi-link-variant"></i>
                      </div>
                    </div>
                    <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">
                      <h6 className="preview-subject font-weight-normal mb-1"><Trans>Launch Admin</Trans></h6>
                      <p className="text-gray ellipsis mb-0">
                        <Trans>New admin wow</Trans>!
                      </p>
                    </div>
                  </Dropdown.Item>
                  <div className="dropdown-divider"></div>
                  <h6 className="p-3 mb-0 text-center cursor-pointer"><Trans>See all notifications</Trans></h6>
                </Dropdown.Menu>
              </Dropdown>
            </li>
            {/*<li className="nav-item nav-profile">*/}
            {/*  <Dropdown alignRight>*/}
            {/*    <Dropdown.Toggle className="nav-link">*/}
            {/*      <div className="nav-profile-img">*/}
            {/*        <img src={src} alt="user"/>*/}
            {/*        <span className="availability-status online"></span>*/}
            {/*      </div>*/}
            {/*      <div className="nav-profile-text">*/}
            {/*        <p className="mb-1 text-black"><Trans>{name}</Trans></p>*/}
            {/*      </div>*/}
            {/*    </Dropdown.Toggle>*/}

            {/*    <Dropdown.Menu className="navbar-dropdown">*/}
            {/*      <Dropdown.Item href="!#" onClick={evt => evt.preventDefault()}>*/}
            {/*        <i className="mdi mdi-cached mr-2 text-success"></i>*/}
            {/*        <Trans>Activity Log</Trans>*/}
            {/*      </Dropdown.Item>*/}
            {/*      <Dropdown.Item onClick={logout}>*/}
            {/*        <i className="mdi mdi-logout mr-2 text-primary"></i>*/}
            {/*        <Trans>Signout</Trans>*/}
            {/*      </Dropdown.Item>*/}
            {/*    </Dropdown.Menu>*/}
            {/*  </Dropdown>*/}
            {/*</li>*/}
            <li className="nav-item nav-profile">
              <div className={style.profile}>
                  <div className="nav-profile-img" onClick={() => handleShow()}>
                    <img src={src} alt="user" referrerPolicy="no-referrer"/>
                    <span className="availability-status online"></span>
                  </div>
              </div>
              <Modal show={isShow} >

                <Modal.Header closeButton onClick={()=> handleClose()} >
                  <Modal.Title>My Profile</Modal.Title>
                </Modal.Header>
                <Modal.Body className="show-grid"  >
                 <div className={style.prof_div_bod1}>
                   <div className={style.prof_logo}>
                     <img src ={src} className={style.prof_mod_img} alt="user" referrerPolicy="no-referrer"/>
                     <div className={style.prof_mod_name}>
                       <p className={style.modal_name}> {name} </p>
                       <p className={style.modal_role}> {role} </p>
                       <div className={style.modal_date}>
                         <p className={style.modal_date_p}>Date Joined </p>
                         <h1 className={style.modal_date_h1}>{regdate} </h1>
                       </div>

                     </div>
                   </div>
                   <button className={style.modal_btn} onClick={editprofile}> Edit Profile</button>

                 </div>
                  <div className={style.prof_div_bod2}>
                    <p className={style.modal_bod2_p}> Contact </p>
                    <div className={style.modal_bod2_div}>
                      <div className={style.modal_bod2_innerdiv1}>
                        <div className={style.modal_bod2_email}>
                         <p className={style.modal_bod2_head}> Email </p>
                          <p className={style.modal_bod2_text}> {email} </p>
                        </div>
                        <div className={style.modal_bod2_copy}>

                        </div>

                      </div>
                      <div className={style.modal_bod2_innerdiv1}>
                        <div className={style.modal_bod2_email}>
                          <p className={style.modal_bod2_head}> Phone number </p>
                          <p className={style.modal_bod2_text}> 0808 900 5544 </p>
                        </div>
                        <div className={style.modal_bod2_copy}>

                        </div>

                      </div>
                      <div>
                        <button className={style.modal_bod2_btn} onClick={logout}> Sign Out</button>
                      </div>

                    </div>

                  </div>


                </Modal.Body>
              </Modal>

            </li>
            {/*<li className="nav-item">*/}
            {/*  <Dropdown alignRight>*/}
            {/*    <Dropdown.Toggle className="nav-link count-indicator">*/}
            {/*      <i className="mdi mdi-email-outline"></i>*/}
            {/*      <span className="count-symbol bg-warning"></span>*/}
            {/*    </Dropdown.Toggle>*/}

            {/*    <Dropdown.Menu className="preview-list navbar-dropdown">*/}
            {/*      <h6 className="p-3 mb-0"><Trans>Messages</Trans></h6>*/}
            {/*      <div className="dropdown-divider"></div>*/}
            {/*      <Dropdown.Item className="dropdown-item preview-item" onClick={evt => evt.preventDefault()}>*/}
            {/*        <div className="preview-thumbnail">*/}
            {/*          <img src={require("../../assets/images/faces/face4.jpg")} alt="user" className="profile-pic"/>*/}
            {/*        </div>*/}
            {/*        <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">*/}
            {/*          <h6 className="preview-subject ellipsis mb-1 font-weight-normal"><Trans>Mark send you a*/}
            {/*            message</Trans></h6>*/}
            {/*          <p className="text-gray mb-0">*/}
            {/*            1 <Trans>Minutes ago</Trans>*/}
            {/*          </p>*/}
            {/*        </div>*/}
            {/*      </Dropdown.Item>*/}
            {/*      <div className="dropdown-divider"></div>*/}
            {/*      <Dropdown.Item className="dropdown-item preview-item" onClick={evt => evt.preventDefault()}>*/}
            {/*        <div className="preview-thumbnail">*/}
            {/*          <img src={require("../../assets/images/faces/face2.jpg")} alt="user" className="profile-pic"/>*/}
            {/*        </div>*/}
            {/*        <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">*/}
            {/*          <h6 className="preview-subject ellipsis mb-1 font-weight-normal"><Trans>Cregh send you a*/}
            {/*            message</Trans></h6>*/}
            {/*          <p className="text-gray mb-0">*/}
            {/*            15 <Trans>Minutes ago</Trans>*/}
            {/*          </p>*/}
            {/*        </div>*/}
            {/*      </Dropdown.Item>*/}
            {/*      <div className="dropdown-divider"></div>*/}
            {/*      <Dropdown.Item className="dropdown-item preview-item" onClick={evt => evt.preventDefault()}>*/}
            {/*        <div className="preview-thumbnail">*/}
            {/*          <img src={require("../../assets/images/faces/face3.jpg")} alt="user" className="profile-pic"/>*/}
            {/*        </div>*/}
            {/*        <div className="preview-item-content d-flex align-items-start flex-column justify-content-center">*/}
            {/*          <h6 className="preview-subject ellipsis mb-1 font-weight-normal"><Trans>Profile picture*/}
            {/*            updated</Trans></h6>*/}
            {/*          <p className="text-gray mb-0">*/}
            {/*            18 <Trans>Minutes ago</Trans>*/}
            {/*          </p>*/}
            {/*        </div>*/}
            {/*      </Dropdown.Item>*/}
            {/*      <div className="dropdown-divider"></div>*/}
            {/*      <h6 className="p-3 mb-0 text-center cursor-pointer">4 <Trans>new messages</Trans></h6>*/}
            {/*    </Dropdown.Menu>*/}
            {/*  </Dropdown>*/}
            {/*</li>*/}
            {/*<li className="nav-item nav-logout d-none d-lg-block">*/}
            {/*  <a className="nav-link" href="!#" onClick={event => event.preventDefault()}>*/}
            {/*    <i className="mdi mdi-power"></i>*/}
            {/*  </a>*/}
            {/*</li>*/}
            {/*<li className="nav-item nav-settings d-none d-lg-block">*/}
            {/*  <button type="button" className="nav-link border-0" onClick={toggleRightSidebar}>*/}
            {/*    <i className="mdi mdi-format-line-spacing"></i>*/}
            {/*  </button>*/}
            {/*</li>*/}
          </ul>
          <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
                  onClick={toggleOffcanvas}>
            <span className="mdi mdi-menu"></span>
          </button>
        </div>
      </nav>

  )

}

export default Navbar;
